import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  Input
} from '@angular/core';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {IdynamicFormItem} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {get, isEmpty, mapKeys, set, find, cloneDeep} from 'lodash';
import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {Subject} from 'rxjs';
import {AgregationService} from "@ispm-client/modules/aggregator/services";

@Component({
  selector: 'ispm-factor-based-form',
  templateUrl: './factor-based-form.component.html',
  styleUrls: ['./factor-based-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('FactorBasedForm')
export class FactorBasedFormComponent implements OnInit, OnDestroy, IWidgetItem, OnChanges {

  private destroyed$: Subject<any> = new Subject();
  private mapConfigParams: any;
  private dataPayload: any;
  private dataIdentifier: string;
  private data = [];
  public formData: {};
  public formId: string;
  public title: string;
  public disabled: boolean = false;

  public emitFormChangeEvenIfInvalid:boolean = false;

  public set widgetDisabledStatus(disabled: boolean) {
    this.disabled = disabled;
  }

  constructor(private _changeDetector: ChangeDetectorRef,
              protected store: Store<IgenomicsState>,
              private _http: HttpInterceptorService,
              private _aggregationService: AgregationService) {
  }

  ngOnInit(): void {
    if (this.dataPayload && isEmpty(this.formData)) {
      this._aggregationService.registerQuery(this.dataPayload, this.dataIdentifier)
        .takeUntil(this.destroyed$.asObservable())
        .subscribe(data => {
          this.data = get(data, `[0].${this.dataIdentifier}`);
          if (this.data) {
            this.mapConfigData(this.data);
          }
        });
    }
  }

  set widgetConfig(widgetConfig: IdynamicFormItem<any>) {
    if (widgetConfig && widgetConfig.widgetPayload) {
      let payload = widgetConfig.widgetPayload;
      this.formId = get(payload, 'formId', '');
      this.mapConfigParams = get(payload, 'mapConfig.params');
      this.emitFormChangeEvenIfInvalid = get(payload, 'emitFormChangeEvenIfInvalid', false);
      this.dataPayload = get(payload, 'mapConfig.itemsDataBinding');
      this.title = get(payload, 'title', '');
      this.dataIdentifier = get(payload, 'mapConfig.dataIdentifier');
    }
  };

  set widgetData(_widgetData: any) {
    if (_widgetData && JSON.stringify(this.formData) !== JSON.stringify(_widgetData)) {
      this.formData = _widgetData;
      this._changeDetector.markForCheck();
    }
  };

  widgetFormInstance: FormGroup;
  widgetFormInstanceSubmitted: boolean;

  widgetSubmitStatusValueCallback(value: boolean): void {
  }

  widgetUpdateValueCallback(value): void {
  }

  /**
   * Emit data to parent widget
   * @param data
   */
  emit(data) {
    if (data) {
      if (this.widgetUpdateValueCallback) {
        this.widgetUpdateValueCallback.apply(this, [data]);
      }
    }
  }


  updateValidate(event) {

  }

  /**
   * Prepare form data from organization or facility
   */
  prepareFormData() {
    if (!isEmpty(this.formData)) {
      this._changeDetector.markForCheck();
    }
  }

  /**
   * map form data based on configuration using org data
   * @param data
   * @private
   */
  private mapConfigData(data) {
    if (isEmpty(this.mapConfigParams)) {
      this.formData = {};
    } else {

      let tempData = {};
      let data = Array.isArray(this.data) ? this.data : [this.data];
      const numberOfFactors = data.length;
      let resolvedKeys = [];
      if (numberOfFactors && numberOfFactors == 1) {
        mapKeys(this.mapConfigParams, (param) => {
          if((!resolvedKeys.includes(get(param, 'destination')))) {
            if (param.hasOwnProperty('valueToSet')) {
              if (this.checkIfValueExist(param, data[0], false)) {
                set(tempData, get(param, 'destination'), get(param, 'valueToSet'));
                resolvedKeys.push(get(param, 'destination'));
              } else if (param.hasOwnProperty('defaultValueToSet')) {
                set(tempData, get(param, 'destination'), get(param, 'defaultValueToSet'));
                resolvedKeys.push(get(param, 'destination'));
              }
            } else {
              set(tempData, get(param, 'destination'), get(data, `[0].${get(param, 'path')}`));
              resolvedKeys.push(get(param, 'destination'));

            }
          }
        });
      } else if (numberOfFactors > 1) {
        mapKeys(this.mapConfigParams, (param) => {
          if ((!resolvedKeys.includes(get(param, 'destination'))) && (param.hasOwnProperty('valueToSet') || param.hasOwnProperty('defaultValueToSet')) && get(param, 'basedOnMultiValue', false)) {
            if (this.checkIfValueExist(param, data, true)) {
              set(tempData, get(param, 'destination'), get(param, 'valueToSet'));
              resolvedKeys.push(get(param, 'destination'));
            } else if (param.hasOwnProperty('defaultValueToSet')) {
              set(tempData, get(param, 'destination'), get(param, 'defaultValueToSet'));
              resolvedKeys.push(get(param, 'destination'));
            }
          }
        });
      }
      this.formData = cloneDeep(tempData);
    }


    this.emit(this.formData);
    this._changeDetector.markForCheck();

  }

  /**
   * Check if Value exists in data
   * @param config
   * @param data
   * @param isArray
   */
  checkIfValueExist(config, data, isArray) {
    if (isArray) {
      return find(data, item => {
        return get(item, get(config, 'searchPath'), '').toLowerCase().trim().includes(get(config, 'searchString', '').toLowerCase().trim());
      });
    } else {
      return get(data, get(config, 'searchPath'), '').toLowerCase().trim().includes(get(config, 'searchString', '').toLowerCase().trim());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
